import { api_ } from '@shared/plugIn/axios';

import { LoginDeviceLock } from './loginDeviceLock.interface';

/**
 * 로그인 기기 잠금 전화 해제 (Admin 전용).
 * 백엔드 스펙: smartbugo-api/docs/login-device-lock.md
 *
 * 제네릭 admin 라우트가 아니라 전용 컨트롤러다 — 잠금 문서를 임의로 고치면
 * 해제 이력(releasedBy·releaseNote)이 남지 않기 때문.
 */

export const LOGIN_DEVICE_LOCK_URL = 'admin/login-device-lock';

/** 목록. username 을 주면 그 아이디로 시도했던 기기만, active 면 지금 잠긴 것만 (최근 50) */
export const listLoginDeviceLocks = async (params: {
  username?: string;
  active?: boolean;
}): Promise<LoginDeviceLock[]> => {
  const search = new URLSearchParams();
  if (params.username) search.set('username', params.username);
  if (params.active) search.set('active', 'true');
  const query = search.toString();
  const { data } = await api_.get<LoginDeviceLock[]>(
    query ? `${LOGIN_DEVICE_LOCK_URL}?${query}` : LOGIN_DEVICE_LOCK_URL,
  );
  return data;
};

/** 한 건 해제. note 는 필수 (누가 왜 풀었는지가 문서에 남는다) */
export const releaseLoginDeviceLock = async (
  id: string,
  note: string,
): Promise<LoginDeviceLock> => {
  const { data } = await api_.patch<LoginDeviceLock>(
    `${LOGIN_DEVICE_LOCK_URL}/${id}/release`,
    { note },
  );
  return data;
};

/** 활성 잠금 전체 해제 — 오작동으로 여러 기기가 잠겼을 때의 비상 손잡이 */
export const releaseAllLoginDeviceLocks = async (
  note: string,
): Promise<{ released: number }> => {
  const { data } = await api_.patch<{ released: number }>(
    `${LOGIN_DEVICE_LOCK_URL}/release-all`,
    { note },
  );
  return data;
};
